<script>
import RecommendationCard from "@/view/components/dashboard/RecommendationCard.vue";
export default {
  name: "recommendations",
  components: {
    RecommendationCard
  },
  props: ["items"]
};
</script>

<template>
  <v-row justify="start">
    <v-col v-for="(item, index) in items" :key="index" md="4">
      <RecommendationCard :item="item"></RecommendationCard>
    </v-col>
  </v-row>
</template>
